module.exports = __webpack_public_path__ + "img/board.88d29ed2.jpg";